module.exports = __webpack_public_path__ + "static/img/help.f77d1461.svg";